import React, { useState, useEffect } from 'react';
import { DiscordIcon } from './Icons';
import { API_URL } from '../config';

function Login({ onLogin }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Vérifier s'il y a une erreur dans l'URL
    const params = new URLSearchParams(window.location.search);
    const errorParam = params.get('error');

    console.log('Login useEffect - errorParam:', errorParam);

    if (errorParam) {
      if (errorParam === 'no_code') {
        setError('Code Discord manquant');
      } else if (errorParam === 'discord_auth_failed') {
        setError('Échec de l\'authentification Discord');
      } else if (errorParam === 'not_authorized') {
        setError('Vous n\'êtes pas autorisé à accéder à cette application. Veuillez contacter un administrateur.');
      } else {
        setError('Erreur d\'authentification');
      }
      // Nettoyer l'URL
      window.history.replaceState({}, document.title, '/login');
    }
  }, []);

  const handleDiscordLogin = () => {
    setError('');
    setLoading(true);
    // Rediriger vers la route Discord OAuth2
    window.location.href = `${API_URL}/api/auth/discord`;
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>
          NexaLogs
        </h1>
        <p style={{ textAlign: 'center', color: '#9ca3af', marginBottom: '30px' }}>
          Système de gestion des logs FiveM
        </p>
        {error && <div className="error-message">{error}</div>}
        <button 
          onClick={handleDiscordLogin} 
          className="btn-discord" 
          disabled={loading}
        >
          <DiscordIcon size={24} />
          {loading ? 'Connexion en cours...' : 'Se connecter avec Discord'}
        </button>
        <p style={{ textAlign: 'center', color: '#6b7280', marginTop: '20px', fontSize: '14px' }}>
          Utilisez votre compte Discord pour vous connecter
        </p>
      </div>
    </div>
  );
}

export default Login;
